export default {"src":"/_next/static/media/graphic-confirmation.2204ce8c.svg","height":170,"width":398,"blurWidth":0,"blurHeight":0};